import React, { useContext } from "react";
import assetsManager from "../assets/assetsmanager/assestsmanager";
import { uploadCta } from "../hooks/uploadCta";
import toast from "react-hot-toast";
import { AppContext } from "../context/context";
const DeepLinkModal = ({
  openModal,
  selectedState,
  setOpenModal,
  setSelectedState,
  getCtaLinks
}) => {
  const { state } = useContext(AppContext);
  const handleClose = () => {
    setOpenModal(false);
  };
  const handleInputChange = (e) => {
    setSelectedState({
      ...selectedState,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.loading("loading...");
    try {
      let response = await uploadCta(selectedState);
      await getCtaLinks();
      handleClose();
      toast.dismiss();
      toast.success("Uploaded Successfully");
    } catch (err) {
      toast.dismiss();
      toast.error("Someting went wrong");
      console.log(err);
    }
  };

  return (
    <div
      className={`editPdfModal backdrop-blur-sm flex items-center justify-center h-full absolute inset-0 bg-[grey] z-[1] bg-opacity-50`}
    >
      <div className="modal rounded-md flex flex-col w-[30rem] max-h-[80vh] overflow-y-auto">
        <div className="bg-white rounded-md relative px-4 py-6">
          <div
            onClick={handleClose}
            className="w-7 h-7 p-2 absolute top-[8px] right-[15px] cursor-pointer"
          >
            <img
              className="h-full w-full"
              src={assetsManager.crossIcon}
              alt="close"
            />
          </div>
          <div className="modal-header text-center text-xl h-[28px] text-[#424242] font-medium ">
            {openModal === "add" ? (
              <p>Add Deep link</p>
            ) : (
              <p>Edit Deep links</p>
            )}
          </div>
          <div className="modal-body px-2  flex flex-col">
            <div className="flex-1 flex flex-col gap-2 ">
              {state?.activeTab !== "ABCD App" && (
                <div className="flex flex-col ">
                  <label className="text-sm text-[#676767] font-medium">
                    LOB
                  </label>
                  <input
                    className="p-2 rounded-[4px] text-[#8A8A8A] text-sm border-[0.5px] border-[#E3E3E3] outline-none disabled:cursor-not-allowed"
                    value={selectedState["lob name"]}
                    name="lob name"
                    placeholder="Enter LOB name here"
                    onChange={handleInputChange}
                  />
                </div>
              )}
              <div className="flex flex-col ">
                <label className="text-sm text-[#676767] font-medium">
                  CTA
                </label>
                <input
                  className="p-2 rounded-[4px] text-[#8A8A8A] text-sm border-[0.5px] border-[#E3E3E3] outline-none disabled:cursor-not-allowed"
                  value={selectedState["cta name"]}
                  name="cta name"
                  placeholder="Enter CTA here"
                  onChange={handleInputChange}
                  disabled={openModal === "edit"}
                />
              </div>
              <div className="flex flex-col ">
                <label className="text-sm text-[#676767] font-medium">
                  CTA Description
                </label>
                <input
                  className="p-2 rounded-[4px] text-[#8A8A8A] text-sm border-[0.5px] border-[#E3E3E3] outline-none disabled:cursor-not-allowed"
                  value={selectedState?.description}
                  name="description"
                  placeholder="Enter CTA Description here"
                  onChange={handleInputChange}
                />
              </div>
              <div className="flex flex-col ">
                <label className="text-sm text-[#676767] font-medium">
                  Deeplinks - APP
                </label>
                <input
                  className="p-2 rounded-[4px] text-[#8A8A8A] text-sm border-[0.5px] border-[#E3E3E3] outline-none disabled:cursor-not-allowed"
                  value={selectedState?.deeplink}
                  name="deeplink"
                  placeholder="Enter link here"
                  onChange={handleInputChange}
                />
              </div>
              {/* <div className="flex flex-col ">
                <label className="text-sm text-[#676767] font-medium">
                  Service Platform deeplink - WEB
                </label>
                <input
                  className="p-2 rounded-[4px] text-[#8A8A8A] text-sm border-[0.5px] border-[#E3E3E3] outline-none disabled:cursor-not-allowed"
                  value={selectedState?.webLink}
                  name="webLink"
                  placeholder="Enter link here"
                  onChange={handleInputChange}
                />
                {formErrors.webLink && (
                  <p className="text-xs text-red-500 text-left">
                    {formErrors.webLink}
                  </p>
                )}
              </div> */}
            </div>
            <button
              className="bg-[#C7222A] mt-4 text-white text-sm flex items-center justify-center w-full h-[39px] rounded-[4px] disabled:cursor-not-allowed"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeepLinkModal;
